import { OutputBlockName } from "../configuration/constants.js";
import { InputDisplayManager } from "./display/inputDisplayManager.js";
import { OutputDisplayManager } from "./display/outputDisplayManager.js";
import { DisplayLedger } from "shared-ui-components/nodeGraphSystem/displayLedger.js";
export const RegisterToDisplayManagers = (globalState) => {
    DisplayLedger.RegisteredControls["InputBlock"] = globalState.blockEditorRegistration?.inputDisplayManager || InputDisplayManager;
    DisplayLedger.RegisteredControls[OutputBlockName] = OutputDisplayManager;
};
//# sourceMappingURL=registerToDisplayLedger.js.map